import { t } from "i18next";
import { Alert, Typography } from "neetoui";
import { Trans } from "react-i18next";

const AlertMessage = ({
  isOpen,
  onClose,
  onSubmit,
  message,
  historyTitle,
  title,
}) => (
  <Alert
    isOpen={isOpen}
    submitButtonLabel={t("buttons.yesContinue")}
    title={t(title)}
    message={
      <Typography>
        <Trans
          components={{ strong: <strong /> }}
          i18nKey={message}
          values={{ historyTitle }}
        />
      </Typography>
    }
    onClose={onClose}
    onSubmit={onSubmit}
  />
);

export default AlertMessage;
